import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  content: {
    paddingTop: 64,
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56,
    },
  },
  inner: {
    maxWidth: 1200,
    width: '100%',
    padding: theme.spacing(5, 3, 4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 2, 3),
    },
  },
}))

export default useStyles
